<!--
 * @Author: wsx
 * @Date: 2022-01-24 11:58:48
 * @LastEditTime: 2022-06-15 16:04:34
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description:小区
-->
<template>
  <div class="PlotTable">
    <h-table
      ref="tableRef"
      v-model:columns="columns"
      :method="leftListquery"
      :params="tableParams"
      @handleClick="handleClick"
    >
    </h-table>
    <regionTransferApplication
      v-if="regionVisible"
      v-model:visible="regionVisible"
      :regionInfo="region"
      :rowInfo="tableRow"
    ></regionTransferApplication>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, watch, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { leftListquery, regioninfodelete } from "@/api/system/region";
import regionTransferApplication from "@/views/system/RegionManage/components/regionTransferApplication.vue";
export default defineComponent({
  name: "PlotTable",
  components: { regionTransferApplication },
  props: {
    region: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, context) {
    const state = reactive({
      tableParams: {
        // apiType: 'plot',
        type: "3",
        name: "",
        id: "",
      },
      columns: [
        { type: "index" },
        {
          label: "社区名称",
          prop: "name",
        },
        {
          label: "小区地址",
          prop: "address",
        },
        {
          label: "物业联系人",
          prop: "contactName",
        },
        {
          label: "物业联系方式",
          prop: "contactPhone",
        },
        {
          label: "面积",
          prop: "unitArea",
        },
        {
          label: "负责人",
          prop: "principal",
        },
        {
          label: "备注",
          prop: "remark",
        },
        {
          label: "经度",
          prop: "longitude",
        },
        {
          label: "纬度",
          prop: "latitude",
        },
        {
          type: "operate",
          label: "操作",
          width: "250px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "详情", emitKey: "detils" },
            { name: "编辑设备", emitKey: "editEquipe" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      regionVisible: false,
      tableRow: {},
    });
    const tableRef = ref(null);
    const refData = toRefs(state);
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    watch(
      () => props.region,
      (v) => {
        if (v.type !== "root") {
          state.tableParams.id = v.id;
          // state.tableParams.type = v.type;
        }
        refreshTable();
      },
      { immediate: true, deep: true }
    );

    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该小区信息吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          async () => {
            const res = await regioninfodelete([row.regionId]);
            if (res.code === 0) {
              refreshTable();
              context.emit("updateOrgan");
              ElMessage({
                type: "success",
                message: "删除成功",
              });
            }
          },
          () => {}
        );
      } else if (emitKey === "edit") {
        context.emit("editOrgan", row);
      } else if (emitKey === "editEquipe") {
        state.tableRow = row;
        state.regionVisible = true;
      } else if (emitKey === "detils") {
        console.log(row, 5555555555);
        context.emit("detils", row);
      }
    };
    return {
      ...refData,
      leftListquery,
      tableRef,
      refreshTable,
      handleClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.PlotTable {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
